import * as ko from 'knockout';
import * as i18nextko from 'i18next-ko';
import type { SelectTypeOption } from '../../../../utils/types';
import type { ReplyCardViewModel } from '../../../reply-card/ko/replyCardViewModel';
import { defaultItemsLimit } from '../../constants';

export class SERPRuntimeViewModel {

    public readonly cards: ko.ObservableArray<ReplyCardViewModel>;

    public readonly cardsTotal: ko.Observable<number>;
    public readonly activePage: ko.Observable<number>;
    public readonly pagesTotal: ko.PureComputed<number>;

    public readonly searchInputValue: ko.Observable<string>;

    public readonly tempCategories: ko.ObservableArray<SelectTypeOption>;
    public readonly categories: ko.ObservableArray<SelectTypeOption>;
    public readonly categoriesOptions: ko.ObservableArray<SelectTypeOption>;

    public readonly tempIndustries: ko.ObservableArray<SelectTypeOption>;
    public readonly industries: ko.ObservableArray<SelectTypeOption>;
    public readonly industriesOptions: ko.ObservableArray<SelectTypeOption>;

    public readonly tempServices: ko.ObservableArray<SelectTypeOption>;
    public readonly services: ko.ObservableArray<SelectTypeOption>;
    public readonly servicesOptions: ko.ObservableArray<SelectTypeOption>;

    public readonly clearAllFilters: ko.PureComputed<boolean>;

    constructor() {
        this.cards = ko.observableArray<ReplyCardViewModel>([]);

        this.cardsTotal = ko.observable<number>();

        this.activePage = ko.observable<number>();

        this.pagesTotal = ko.pureComputed<number>(() => Math.ceil(this.cardsTotal() / defaultItemsLimit));

        this.searchInputValue = ko.observable<string>();

        this.tempCategories = ko.observableArray<SelectTypeOption>([]);
        this.categories = ko.observableArray<SelectTypeOption>([]);
        this.categoriesOptions = ko.observableArray<SelectTypeOption>([]);

        this.tempIndustries = ko.observableArray<SelectTypeOption>([]);
        this.industries = ko.observableArray<SelectTypeOption>([]);
        this.industriesOptions = ko.observableArray<SelectTypeOption>([]);

        this.tempServices = ko.observableArray<SelectTypeOption>([]);
        this.services = ko.observableArray<SelectTypeOption>([]);
        this.servicesOptions = ko.observableArray<SelectTypeOption>([]);

        this.clearAllFilters = ko.pureComputed<boolean>({
            read: () => {
                return this.categories().length > 0
                    || this.industries().length > 0
                    || this.services().length > 0
            },
            write: () => {
                if (this.categories().length) {
                    this.categories([]);
                }
                if (this.industries().length) {
                    this.industries([]);
                }
                if (this.services().length) {
                    this.services([]);
                }
            },
            owner: this
        });
    }

    public static optionsSort(a: SelectTypeOption, b: SelectTypeOption) {
        return a.label.localeCompare(b.label);
    }

    public t(key: string): ko.Computed<string> {
        return i18nextko.t(key);
    }

    public resultsInfo(): ko.Computed<string> {
        const page = this.activePage();
        const total = this.cardsTotal() ?? 0;

        if (total === 1) {
            return i18nextko.t('search_count_one');
        } else if (total < 11) {
            return i18nextko.t('search_count_other', { count: total });
        } else {
            const start = (page - 1) * defaultItemsLimit + 1;
            const end = page * defaultItemsLimit > total ? total : page * defaultItemsLimit;
            return i18nextko.t('search_count_multiple', { count: `${start}-${end}`, total });
        }
    }
}
